import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSuperAdminLogsAction = createAsyncThunk(
    'get-super-admin-logs',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-super-admin-logs?`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSuperAdminLogsSlice = createSlice({
    name: 'get-super-admin-logs',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSuperAdminLogsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSuperAdminLogsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSuperAdminLogsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSuperAdminLogsReducer = getSuperAdminLogsSlice.reducer